import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-transition",
  "use": "icon-transition-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-transition\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M4,19H20V5H4ZM22,4V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3H21A1,1,0,0,1,22,4ZM11.88,12.22,6.4,16a.26.26,0,0,1-.4-.22V8.26A.26.26,0,0,1,6.4,8l5.48,3.74a.26.26,0,0,1,0,.44ZM12,12a.25.25,0,0,1,.12-.22L17.6,8a.26.26,0,0,1,.4.22v7.48a.26.26,0,0,1-.4.22l-5.48-3.74A.25.25,0,0,1,12,12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol